import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {sendBackReport} from '@custom/rtk-apis/myworklist/sendBackreport';
import { SendBackReportState } from '@custom/Utils/constants/interfaces';

export const initialState: SendBackReportState = {
  loading: false,
  status: null,
  result: null,
  message: null,
  error: null,
};

const sendBackReportSlice = createSlice({
  name: 'sendBackReport',
  initialState,
  reducers: {
    resetSendBackReportState: (state) => {
      state.loading = false;
      state.status = null;
      state.result = null;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendBackReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendBackReport.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload.status;
        state.result = action.payload.result;
        state.message = action.payload.msg;
      })
      .addCase(sendBackReport.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload || 'Failed to send back report';
      });
  },
});

// Export the action to reset the state
export const { resetSendBackReportState } = sendBackReportSlice.actions;

// Export the reducer to add to the store
export default sendBackReportSlice.reducer;
